import { interpolate, appendHtml } from '../utils';

var template = `
<div class="desktop-modal" id="\${data.id}">
  <div class="desktop-modal_overlay js-overlay-close"></div>
  <div class="desktop-modal_container" style="--modal-height: \${data.height}">
    <div class="desktop-modal_header">
        \${data.title}
        <button type="button" class="desktop-modal_close js-close">
            <img src="/Content/reskin/src/assets/img/gr-close.svg" alt="X" />
        </button>
    </div>
    <div class="desktop-modal_body">
        \${data.content}
    </div>
  </div>
</div>
`;

var defaultOptions = {
    title: 'Desktop Modal',
    content: 'Hello World',
    height: '50%',
    overlayClose: true
};

export default function DesktopModal(options) {
    this.config = Object.assign({
        id: `modal_${new Date().valueOf()}`
    }, defaultOptions, options || {});

    this.create();
};

DesktopModal.prototype.create = function () {
    var data = this.config;
    var html = interpolate(template, { data: { id: this.config.id, ...data } });
    appendHtml(html);
    this.el = document.getElementById(this.config.id);
    var closeBtn = this.el.querySelector('.js-close');
    closeBtn.addEventListener('click', this.hide.bind(this));

    if (this.config.overlayClose) {
        var overlay = this.el.querySelector('.js-overlay-close');
        overlay.addEventListener('click', this.hide.bind(this));
    }

    this.show();
};

DesktopModal.prototype.show = function () {
    this.el.classList.add('desktop-modal--show');
    document.body.style.overflowY = "hidden";
};

DesktopModal.prototype.hide = function () {
    this.el.classList.remove('desktop-modal--show');
    document.body.style.overflowY = "auto";
    this.el.remove();
};